import { render, staticRenderFns } from "./OrderSummaryShipping.vue?vue&type=template&id=356ef067&"
import script from "./OrderSummaryShipping.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports